/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";

// third-party imports
import { FaLinkedinIn, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { IoCopyOutline, IoShareSocialOutline } from "react-icons/io5";

// project imports
import ToolTip from "../../common/Tooltip/ToolTip";
import { useUserContext } from "../../context/user_context";
import { useOrderContext } from "../../context/order_context";
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { formatViews, handleDiscountedPrice, handleMonthlyPrice } from "../../utils/course";
import ModalLogin from "../form/ModalLogin";
import Image from "../../common/footer/Images/Image";
import TalkToSalesForm from "./TalkToSalesForm";
import { maskPrice } from "../../utils";


const TrainingProgramInfo = ({ data, activeStatus }) => {

    // reading context variables and methods
    const { loginData } = useUserContext();
    const {
        fetchOrders,
        orderLoading,
    } = useOrderContext();

    // State variables
    const [toggler, setToggler] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [showTalkToSalesModal, setShowTalkToSalesModal] = useState(false);

    const member =
        loginData && loginData?.data && loginData?.data?.userId
            ? loginData?.data
            : [];

    const text = `Check out the '${data?.name}' from the Longswitch Academy`;
    const url = window.location.href;

    const message = encodeURIComponent(`${text} ${url}`);

    const duration = data && data?.pricing && data?.pricing?.billingCycle ? data?.pricing?.billingCycle : "";
    const level = data && data?.metadata && data?.metadata?.levels ? data?.metadata?.levels : "";
    const download = data && data?.metadata && data?.metadata?.downloads ? data?.metadata?.downloads : 0;
    const offeringLanguage = data && data?.metadata && data?.metadata?.language ? data?.metadata?.language : "";

    const isDiscountValid = (data) => {
        try {
            if (
                data?.discount?.hasDiscount &&
                handleDiscountedPrice(data, false)?.isValid
            ) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log(
                "173 : Pricing : Error in isDiscountValid : ",
                error && JSON.stringify(error)
            );
        }
    };


    const toggleTalkToSalesModal = () => {
        try {
            setShowTalkToSalesModal(!showTalkToSalesModal);
        } catch (error) {
            console.error(
                "114 : TestimonialForm : Error occurred in toggleTalkToSalesModal:",
                error && JSON.stringify(error)
            );
        }
    };

    // Social media share handlers
    const handleCopyLink = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_COPY_COURSE_LINK);
            navigator.clipboard.writeText(
                url
            );
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 1000);
            return;
        } catch (error) {
            console.log("72 : CourseInfo : Error while sharing on copy link :", error && JSON.stringify(error));
        }
    };

    const handleWhatsAppShare = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SHARE_ON_WHATSAPP);
            window.open(`https://wa.me/?text=${message}`, "_blank");
            setToggler(false);
        } catch (error) {
            console.log("82 : CourseInfo : Error while sharing on whatsapp :", error && JSON.stringify(error));
        }
    };

    const handleTwitterShare = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SHARE_ON_TWITTER);
            window.open(`https://twitter.com/intent/tweet?text=${message}`, "_blank");
            setToggler(false);
        } catch (error) {
            console.log("141 : CourseInfo : Error while sharing on twitter :", error && JSON.stringify(error));
        }
    };

    const handleLinkedInShare = () => {
        try {
            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_SHARE_ON_LINKEDIN);
            window.open(
                `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
                "_blank"
            );
            setToggler(false);
        } catch (error) {
            console.log("154 : CourseInfo : Error while sharing on linked in :", error && JSON.stringify(error));
        }
    };

    // TODO: 09242026 - Commented this
    // useEffect(() => {
    //     if (member && member?.userId) {
    //         const userUniqueId = member && ((member?.firebaseUid ? member?.firebaseUid : member?.userRecordId));

    //         fetchOrders(userUniqueId);
    //     }
    // }, [orderLoading, member]);

    return (
        <div className="eduvibe-sidebar course-details-sidebar mt-0">
            <div className="inner">
                <div className="eduvibe-widget">
                    <div className="video-area">
                        <div className="thumbnail">
                            {/*  Orginal code for course image start 16/12/2024 */}

                            {/* <img className="radius-small w-100" src={`${process.env.PUBLIC_URL}/images/course/video-bg/${data.image}`} alt="Course Video Thumb" onError={onImageError} /> */}
                            <div className="thumbnail">
                                <Image src={`${process.env.PUBLIC_URL}/images/offerings/${data?.media?.thumbnailUrl}`} alt={data?.name} className="w-100" fill />

                                {isDiscountValid(data) ? (
                                    <div className="wrap">
                                        <span className="ribbon6 fs-5 fw-bold">
                                            {/* {data?.discount?.discountLabel || ""} */}
                                            Discount Available
                                        </span>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>

                        </div>
                        <div className="card-bottom mt--20">
                            <div className="price-wrap">
                                <div className="salesforceAdmin-pricing">
                                    {/* {isDiscountValid(data) && (
                                        <span className="fs-4 fw-bold text-decoration-line-through">
                                            {maskPrice(handleMonthlyPrice(data).formattedAmount)}
                                        </span>
                                    )} */}
                                    <span className="amount fs-1">
                                        {isDiscountValid(data)
                                            ? maskPrice(handleDiscountedPrice(data, true)?.formattedAmount)
                                            : maskPrice(handleMonthlyPrice(data).formattedAmount)}
                                    </span>
                                    <span className="fs-3 duration mx-1">
                                        /{data?.pricing?.priceType}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="eduvibe-widget-details mt--20">
                        <div className="widget-content">
                            <ul>
                                <li>
                                    <span>
                                        <i className="icon-time-line"></i> Duration
                                    </span>
                                    <span>{duration || 0}</span>
                                </li>

                                <li>
                                    <span>
                                        <i className="icon-bar-chart-2-line"></i> Level
                                    </span>
                                    <span>{level || "Beginner"}</span>
                                </li>

                                <li>
                                    <span>
                                        <i class="ri-download-line"></i> Downloads
                                    </span>
                                    <span>{download || 0}</span>
                                </li>

                                <li>
                                    <span>
                                        <i className="icon-translate"></i> Language
                                    </span>
                                    <span>{offeringLanguage || "English"}</span>
                                </li>

                            </ul>

                            <div className="read-more-btn mt--20">
                                <button className="edu-btn w-100 text-center" onClick={toggleTalkToSalesModal}>
                                    Talk to Sales
                                </button>
                            </div>

                            <div className="read-more-btn mt--30 text-center">
                                <div className="eduvibe-post-share flex">
                                    <span className="mx-auto">Share : </span>
                                    <a
                                        className="linkedin mx-auto"
                                        href={""}
                                        onClick={handleLinkedInShare}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaLinkedinIn />
                                    </a>

                                    <a
                                        className="Instagram mx-auto"
                                        href={""}
                                        target="_blank"
                                        rel="noreferrer"
                                        onClick={handleTwitterShare}
                                    >
                                        <FaTwitter />
                                    </a>
                                    <a
                                        className="youtube mx-auto"
                                        href={""}
                                        onClick={handleWhatsAppShare}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaWhatsapp />
                                    </a>

                                    <a
                                        className="youtube mx-auto"
                                        onClick={handleCopyLink}
                                    >
                                        <ToolTip title={isCopied ? "Copied" : "Click to Copy URL"}>
                                            <IoCopyOutline />
                                        </ToolTip>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showTalkToSalesModal && (
                    <TalkToSalesForm
                        show={showTalkToSalesModal}
                        data={data}
                        onCloseModal={toggleTalkToSalesModal}
                        title={"Submit Review"}
                        formStyle="rnt-contact-form rwt-dynamic-form row"
                    />
                )}

            </div>
        </div>
    );
};

export default TrainingProgramInfo;
